export enum UserRole {
  Admin = 'Admin',
  OrganizationAdmin = 'Organization Admin',
  GeneralPractitioner = 'General Practitioner',
  Assistant = 'Assistant',
  Internist = 'Internist',
}
